import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function TestimoniosHero() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 24, duration: 800 });

  return (
    <section ref={ref} className="relative w-full bg-brand-black overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant-haute-couture-atelier-portrait-session-clients-with-garments-soft-golden-lighting-warm-tones-luxury-fashion-editorial-photography-grain-texture-minimal-background-landscape-orientation&width=1920&height=1080&seq=105&orientation=landscape"
          alt="Testimonios clientes Anthony Sánchez Couture"
          className="w-full h-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-brand-black/60 via-brand-black/40 to-brand-black/80" />
      </div>

      <div className="relative z-10 px-6 lg:px-[7%] pt-40 pb-20 md:pt-48 md:pb-28">
        <div className="max-w-3xl mx-auto text-center" style={style}>
          <span className="font-sans text-brand-gray-300 text-[11px] tracking-[0.2em] uppercase font-medium">
            Voz de nuestros clientes
          </span>
          <h1 className="font-serif text-white text-[clamp(2.5rem,5vw,4rem)] font-semibold leading-[1.1] mt-5">
            Lo que dicen
            <br />
            <span className="italic text-brand-gray-200">quienes nos conocen</span>
          </h1>
          <p className="font-sans text-brand-gray-300 text-base md:text-lg leading-[1.8] mt-6 max-w-xl mx-auto">
            Cada prenda cuenta una historia, pero la historia más importante es la de
            quien la lleva. Estas son las experiencias reales de quienes han confiado
            en nuestro atelier.
          </p>
        </div>
      </div>
    </section>
  );
}